import {Component, Input} from "@angular/core";
import {Store} from "@ngrx/store";
import * as fromQuote from '../../../reducers/index';
import * as quoteActions from '../../actions/quote.action';
import {QuoteState, Quote} from "../../model/quote";

@Component({
    selector: 'choose-quote',
    styleUrls: ['./choose-quote.component.scss'],
    templateUrl: './choose-quote.component.html'
})
export class ChooseQuoteComponent {
    _quotes: Quote[];
    constructor(private store: Store<fromQuote.State>) {}

    @Input() set quotes(quotes: Quote[]) {
        this._quotes = quotes.filter(quote => quote.state == QuoteState.NEW);
    }

    get quotes(): Quote[] {
        return this._quotes;
    }

    closeSelectNewQuote() {
        this.store.dispatch(quoteActions.closeChooseQuote());
        this.store.dispatch(quoteActions.openAddToQuoteMenu());
    }

    changeSelectedQuote(selectedQuote) {
        let foundQuote;
        this.quotes.map(quote => {
            if(quote.id === +selectedQuote.id) {
                foundQuote = quote;
            }
        });
        if (foundQuote) {
            console.log("Changed Chosen Quote to: " + foundQuote);
            this.store.dispatch(quoteActions.changeChosenQuote({chosenQuote: foundQuote}));
        }
        this.closeSelectNewQuote();
    }
}
